import React, { useState, useEffect } from 'react';
import './menu.css';

const gestionDeAlmacenMenu = [
  // Nivel principal: Tránsitos
  {
    title: 'Tránsitos',
    icono: 'Dashboard.svg',
    enlace: '#', // Original: null
    activo: 'conexiones/tránsitos',
    permiso: [1000, 1001], // Rango original: 1000 a 1001
    hijos: [
      {
        title: 'Milestones',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('transits.milestones')
        activo: 'conexiones/tránsitos/milestones',
        permiso: [1000],
      },
      {
        title: 'Altas Tránsitos',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('add_extras')
        activo: 'conexiones/tránsitos/altas_tránsitos',
        permiso: [1001],
      },
    ],
  },

  // Nivel principal: Incidencias
  {
    title: 'Incidencias',
    icono: 'Dashboard.svg',
    enlace: '#', // Modificado de URL::route('incidents')
    activo: 'conexiones/incidencias',
    permiso: [1002],
    hijos: [],
  },

  // Nivel principal: Kardex
  {
    title: 'Kardex',
    icono: 'Dashboard.svg',
    enlace: '#', // Modificado de URL::route('reports.kardex_transits')
    activo: 'conexiones/kardex',
    permiso: [1003],
    hijos: [],
  },

  // Nivel principal: Reportes Tránsitos
  {
    title: 'Reportes Tránsitos',
    icono: 'Dashboard.svg',
    enlace: '#', // Original: null
    activo: 'conexiones/reportes_tránsitos',
    permiso: [1004, 1005, 1006, 1007], // Rango original: 1004 a 1007
    hijos: [
      {
        title: 'Inventario Tránsitos',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.transits_stock')
        activo: 'conexiones/reportes_tránsitos/inventario_tránsitos',
        permiso: [1004],
      },
      {
        title: 'Histórico',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.transits_inventory')
        activo: 'conexiones/reportes_tránsitos/histórico',
        permiso: [1005],
      },
      {
        title: 'Histórico Almacenes Externos',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.transits_external_warehouses')
        activo: 'conexiones/reportes_tránsitos/almacenes_externos',
        permiso: [1006],
      },
      {
        title: 'Tiempos de Conexión',
        icono: 'Dashboard.svg',
        enlace: 'Report_transit', // Modificado de URL::route('reports.transits')
        activo: 'conexiones/reportes_tránsitos/tránsitos',
        permiso: [1007],
      },
    ],
  },

  // Nivel principal: Dashboard de Tránsitos
  {
    title: 'Dashboard de Tránsitos',
    icono: 'Dashboard.svg',
    enlace: '#', // Original: null
    activo: 'conexiones/dashboard_de_tránsitos',
    permiso: [1008],
    hijos: [
      {
        title: 'KPI Tránsitos Subprocesos',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.transits_kpi')
        activo: 'conexiones/dashboard_de_tránsitos/kpis_tránsitos',
        permiso: [1008],
      },
    ],
  },
];

const MenuItem = ({ item, activePath, onSetActive, onHoverChange, hoveredItem, onComponentChange }) => {
    
    const [isOpen, setIsOpen] = useState(false); 
    const hasChildren = item.hijos && item.hijos.length > 0;
    
    // Defensa: Asegura que activePath sea un string para evitar el error "undefined.startsWith"
    const currentPath = activePath || ''; 
    
    // Lógica para determinar el resaltado
    const isCurrentActive = item.activo === currentPath;
    const isAncestorActive = currentPath.startsWith(item.activo + '/') && !isCurrentActive;

    // Colapso automático/apertura si es parte del path activo
    useEffect(() => {
        if (isAncestorActive || isCurrentActive) {
            setIsOpen(true);
        }
    }, [isAncestorActive, isCurrentActive]);
    
    // Lógica de Hover (se mantiene)
    const isHighlighted = (item.title === hoveredItem); 
    const hoverProps = hasChildren ? {
        onMouseEnter: () => onHoverChange(item.title),
        onMouseLeave: () => onHoverChange(null),
    } : {};


    // FUNCIÓN CLAVE: Manejo de Clic y Notificación con Doble Argumento
    const handleItemClick = (e) => {
        
        // 1. Lógica de Colapso (Si tiene hijos)
        if (hasChildren) {
            e.preventDefault(); 
            setIsOpen(!isOpen);
        } 
        
        // 2. Lógica de Navegación/Selección (Elementos hoja)
        else {
            e.preventDefault();
            
            if (onComponentChange) {
                // Notifica a Admin.js: Envía el Nombre del Componente y la Ruta Activa
                onComponentChange(item.enlace, item.activo); 
            }
            
            // onSetActive ya no se llama localmente porque Admin.js lo maneja.
        }
    };

    // Determina las clases de estilo (se mantiene)
    let itemClass = '';
    if (isCurrentActive) {
        itemClass = 'is-active'; 
    } else if (isAncestorActive) {
        itemClass = 'is-ancestor';
    }


    return (
        <li 
            className={`menu-item ${item.activo} ${itemClass} ${isHighlighted ? 'highlighted' : ''}`}
            {...hoverProps} 
        >
            <a 
                href={item.enlace} 
                onClick={handleItemClick}
                className="menu-link text-white px-3 d-flex justify-content-between align-items-center" 
            >
                {item.title}
                {hasChildren && <span className="arrow">{isOpen ? '▲' : '▼'}</span>} 
            </a>
            
            {/* Llamada Recursiva: Pasamos todos los props necesarios */}
            {hasChildren && (
                <ul className="submenu" style={{ display: isOpen ? 'block' : 'none' }}>
                    {item.hijos.map((child, index) => (
                        <MenuItem 
                            key={index} 
                            item={child} 
                            activePath={activePath} 
                            onSetActive={onSetActive} // Dummy
                            onHoverChange={onHoverChange}
                            hoveredItem={hoveredItem}
                            onComponentChange={onComponentChange} // <-- ¡Pasado recursivamente!
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

const MenuGestion = ({ activePath, onComponentChange }) => { 
    
    // Estados locales (solo Hover)
    const [hoveredItem, setHoveredItem] = useState(null);
    const handleHoverChange = (title) => { setHoveredItem(title); };
    
    // Función dummy para onSetActive (ya no gestiona el estado, solo cumple la firma)
    const handleSetActiveDummy = () => {}; 
    
    return (
        <nav className="menu-importacion">
            <ul className="menu-list">
                {gestionDeAlmacenMenu.map((item, index) => (
                    <MenuItem 
                        key={item.title || index} 
                        item={item} 
                        activePath={activePath} // <-- Recibido de Admin.js
                        onSetActive={handleSetActiveDummy} 
                        onHoverChange={handleHoverChange} 
                        hoveredItem={hoveredItem}
                        onComponentChange={onComponentChange} // <-- Función enviada al fondo
                    /> 
                ))}
            </ul>
        </nav>
    );
};



export default MenuGestion;